export default __webpack_public_path__ + "slices/main/assets/public/media/logos/fastcompany.d4678d762008ad90ad5117a45220fe3e.png";